import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
export const useAdaptiveStickyColomn = t0 => {
  const $ = _c(5);
  const {
    indent,
    minHeight: t1
  } = t0;
  const minHeight = t1 === undefined ? 200 : t1;
  const adaptiveElementRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== indent || $[1] !== minHeight) {
    t2 = () => {
      const resizeFilter = () => {
        if (adaptiveElementRef.current) {
          const clientRect = adaptiveElementRef.current.getBoundingClientRect();
          const windowInnerHeight = window.innerHeight;
          adaptiveElementRef.current.style.height = Math.max(windowInnerHeight - clientRect.top - indent, minHeight) + "px";
        }
      };
      resizeFilter();
      window.addEventListener("scroll", resizeFilter);
      window.addEventListener("resize", resizeFilter);
      return () => {
        window.removeEventListener("scroll", resizeFilter);
        window.removeEventListener("resize", resizeFilter);
      };
    };
    t3 = [indent, minHeight];
    $[0] = indent;
    $[1] = minHeight;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      adaptiveElementRef
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};